if($(window).width() < 767){
  /* $(document).on('keyup','.main-search__input', function () {
        if($(this).val() !== "") {
            $(".main-search__button").show();
        } else {
            $(".main-search__button").hide();
        }
    });*/ 
  $(document).on("click",".navigation__tier-1 .first-tier-link",function (e){
    e.preventDefault(); 
    if($(this).parents("li").hasClass('active')){
      $(this).parents("li").removeClass("active");
    }else{
        $(".navigation__tier-1 .navigation__item").removeClass("active");
        $(this).parents("li").addClass("active");
    }
  })
 $(document).on("click","a.navigation__link",function() {
   $(this).parents("li").removeClass("active");
  var url = $(this).attr("href");
  window.location.href = url;
 })
  $(".template-collection .collection-block").each(function(){
  var _text = $(this).find(".product-block__title").text();
 if( $( ".collection-slider-row" ).hasClass( _text )){
   $(this).addClass("active");
 }
})
  setTimeout(function(){
     $('.related-collection .owl-carousel').owlCarousel({
            loop: true,
            margin: 10,
            responsiveClass: true,
            autoplay: false,
            nav: true,
            responsive: {
                0: {
                    items: 1, // Show 1 item on mobile
                },
                600: {
                    items: 2, // Show 2 items on tablets
                },
                1000: {
                    items: 3 // Show 3 items on desktops
                }
            }
        });
    
  },1000)
     

}
$(document).ready(function() {
    // Owl Carousel
   $('.cart-drawer__content .owl-carousel').owlCarousel({
    loop:true
  })
setTimeout(function(){
 
  $(".cart-drawer__content .owl-carousel .owl-item").each(function(){
   if ( $(this).find('div').length > 0 ) {
  }
   else{
     $(this).hide()
   }
 })
},2000)  
 
}) 
$(document).ready(function() {
  $('.main-div').each(function() {
    var $productblock = $(this);
    var $innerProduct = $productblock.find('.inner-product');
    var $innerCollection = $productblock.find('.inner-collection');
    
    var innerProductHeight = $innerProduct.height();
    var adjustedHeight = innerProductHeight - 20; // Decrease height by 20px
    $innerCollection.height(adjustedHeight);
  });
  
  $(".selectt").click(function() {
  var is_open = $(this).hasClass("open");
  if (is_open) {
    $(this).removeClass("open");
  } else {
    $(this).addClass("open");
  }
});

$(".selectt li").click(function() {

  var selected_value = $(this).html();
  var first_li = $(".selectt li:first-child").html();

  $(".selectt li:first-child").html(selected_value);
  $(this).html(first_li);

});

$(document).mouseup(function(event) {

  var target = event.target;
  var select = $(".selectt");

  if (!select.is(target) && select.has(target).length === 0) {
    select.removeClass("open");
  }

});
});

// popup custom product
$(document).ready(function() {
  if ($('.popup-product').length > 0) {
     $('.popup-product').insertBefore('.buy-buttons-row');
  }
})
$.get("https://ipinfo.io/json", function (response) {
    if(response.country == "DE"){
      
    }
  else{
    $(".free-shipping-bar").hide();
  }
}, "jsonp");


 var domModified = false;
    
    // Function to execute when DOM is modified
    function onDomModified() {
        // Your code to run when DOM is modified
        console.log("DOM Modified. Running code...");
        $.ajax({
            url: '/cart.json', // URL to Shopify's cart.json endpoint
            type: 'GET',
            dataType: 'json',
            success: function(data) {
              console.log(data);
             var dis = data.original_total_price - data.total_price;
              if(data.total_discount == 0){
                
                  $('.final').hide();
                  $('.subtotal1').show();
                }
                else{
                    $('.final .money').text('€'+(data.original_total_price / 100).toFixed(0));
                    $('.final .finalprice').text('€'+(data.total_price / 100).toFixed(0));
                    $('.final').show();
                    $('.subtotal1').hide();
                }
            },
            error: function(xhr, status, error) {
                console.error('Error fetching cart JSON:', error);
            }
        });
        // Reset flag after executing code
        domModified = false;
    }
    
    // Function to handle DOM modification event
    function handleDomModification() {
        // Set flag to true when DOM is modified
        domModified = true;
        
        // If there's already a timer set, clear it
        if (window.domModifiedTimer) {
            clearTimeout(window.domModifiedTimer);
        }
        
        // Set timer to execute code after a delay
        window.domModifiedTimer = setTimeout(function() {
            // Check if DOM was modified during the delay
            if (domModified) {
                onDomModified();
            }
        }, 1500); // Adjust the delay (in milliseconds) as needed
    }
    
    // Event handler for DOM modification (using delegation)
    $('.subtotal1').on('DOMSubtreeModified', handleDomModification);
